'use client';

import { Box, Typography } from '@mui/material';

interface SearchSectionHeaderProps {
  title: string;
  icon?: any;
}

export const SearchSectionHeader = ({ title, icon: Icon }: SearchSectionHeaderProps) => (
  <Box sx={{ px: 1, pb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
    {Icon && <Icon sx={{ fontSize: 18, color: 'text.secondary' }} />}
    <Typography
      variant="caption"
      sx={{
        fontSize: '0.75rem',
        fontWeight: 700,
        color: 'text.secondary',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        opacity: 0.8,
      }}
    >
      {title}
    </Typography>
  </Box>
);
